import React from 'react';
import { Box, Stack, useTheme } from '@mui/material';
import { FileIcon } from '@components/atoms/Icon';
import { Typography } from '@components/atoms/Typography';
import { ProgressBar } from '@components/atoms/ProgressBar';
import { FileUploadStatusProps } from './FileUploadStatus.props';

/**
 * FileUploadStatus - Pure presentational component for displaying file upload status
 *
 */
export const FileUploadStatus: React.FC<FileUploadStatusProps> = ({
  title,
  fileExtension,
  subTitle,
  progress = 0,
  showProgressBar,
  rightContent,
  sx,
}) => {
  const theme = useTheme();

  return (
    <Stack>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: 2,
          maxWidth: '100%',
          ...sx,
        }}
      >
        <FileIcon extension={fileExtension} />
        <Stack sx={{ flex: 1 }}>
          <Typography
            sx={{
              color: theme.palette.M3.sys.light['on-surface'],
              ...theme.typography.M3.label.large,
            }}
          >
            {title}
          </Typography>
          <Typography
            sx={{
              color: theme.palette.M3.sys.light['on-surface-variant'],
              ...theme.typography.M3.body.medium,
            }}
          >
            {subTitle}
          </Typography>
        </Stack>
        {rightContent}
      </Box>
      {showProgressBar && <ProgressBar value={progress} showLabel />}
    </Stack>
  );
};

export default FileUploadStatus;
